var map = {
	"./geoff_blog_transparent.png": 4138,
	"./image-20250326-121921.png": 32152,
	"./image-20250410-102702.png": 74520,
	"./the_final_furlong_logo_black_pink.jpg": 95986,
	"./the_final_furlong_logo_black_white.jpg": 83283,
	"./the_final_furlong_logo_black_yellow.jpg": 87774,
	"./the_final_furlong_logo_white.png": 62447
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 10863;